import { URL_PARAM_APPLICATION_ID } from '@funnels/constants';

export const BASE_NAME = `/application/:${URL_PARAM_APPLICATION_ID}/post-product-select/`;
export const APPLICANT_BASE_NAME = `/application/:${URL_PARAM_APPLICATION_ID}/post-product-select/applicant/`;
export const PROPERTIES_BASE_NAME = `/application/:${URL_PARAM_APPLICATION_ID}/post-product-select/property/`;
export const ACCOUNTANTS_BASE_NAME = `/application/:${URL_PARAM_APPLICATION_ID}/post-product-select/accountant/`;
export const SOLICITOR_BASE_NAME = `/application/:${URL_PARAM_APPLICATION_ID}/post-product-select/conveyancer/`;
export const LINCENSED_BUILDER_BASE_NAME = `/application/:${URL_PARAM_APPLICATION_ID}/post-product-select/licensed-builder/`;
export const ACCOUNT_DETAILS_BASE_NAME = `/application/:${URL_PARAM_APPLICATION_ID}/post-product-select/account-details/`;
